export enum FormMode {
  Edit = 'edit',
  Add = 'add'
}
